<template>
    <InputNumber :value="value"
        :max="max"
        :min="min"
        :size="size"
        :active-change="false"
        :disabled="disabled"
        :readonly="readonly"
        :precision="precision"
        class="number-input"
        @on-change="onChange"
        @on-focus="onFocus"/>
</template>

<script>
import './number.less';
import NumberMixins from './number-mixins';

export default {
    name: 'IntegerInput',
    mixins: [NumberMixins],
    props: {
        precision: {
            type: Number,
            default: 0
        },
        size: {
            type: String,
            default: 'default'
        }
    },
    data() {
        return {};
    },
    methods: {
        onFocus(e){
            e.target.select();
        }
    }
    
};
</script>

<style scoped>
</style>
